import { UserCheck } from "lucide-react";
import { SectionTitle } from "@/components/contractings/detail-parts";
import { AssigneeSelect } from "./AssigneeSelect";
import { useTeam } from "@/hooks/queries/useTeam";

/**
 * Quién del equipo lleva esta licitación, en el detalle. No se renderiza en
 * cuentas individuales: sin equipo no hay reparto que mostrar.
 */
export function TeamCard({
  contractingId,
  assignedUserId,
}: {
  contractingId: number;
  assignedUserId: string | null;
}) {
  const { data: team } = useTeam();
  if (!team?.isTeam) return null;

  return (
    <div className="flex flex-col">
      <SectionTitle icon={<UserCheck className="size-4 text-primary" />}>
        Responsable
      </SectionTitle>
      <div className="mt-3 flex flex-col gap-2 rounded-2xl border bg-card p-5">
        <AssigneeSelect
          contractingId={contractingId}
          assignedUserId={assignedUserId}
        />
        {!assignedUserId && (
          <p className="text-xs text-slate-400 dark:text-slate-500">
            Nadie la está trabajando todavía.
          </p>
        )}
      </div>
    </div>
  );
}
